import { ISOCountryCode } from '@pmi.web/countries';
import { EmailInput, PhoneInput, TextInput } from '@pmi.web/react-inputs';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { IAddress } from '../../types/IAddress';
import { AddressInput } from '../common/address-input/AddressInput';
import { Form } from '../common/Form';
import { IFormProps } from '../common/Form.types';

export interface IShippingAddressFormData {
  readonly fullName?: string;
  readonly email?: string;
  readonly phone?: string;
  readonly mobile?: string;
  readonly address?: IAddress;
}

export function ShippingAddressForm(
  props: IFormProps<IShippingAddressFormData>,
) {
  const {
    formId,
    country,
    language,
    className,
    defaultValues = {},
    businessLogicErrors = {},
    onSubmit,
  } = props;

  return (
    <Form<IShippingAddressFormData>
      formId={formId}
      language={language}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      businessLogicErrors={businessLogicErrors}
      className={className}
    >
      <ShippingAddressFormContent country={country} />
    </Form>
  );
}

interface IShippingAddressFormContentProps {
  readonly country: ISOCountryCode;
}

function ShippingAddressFormContent({
  country,
}: IShippingAddressFormContentProps) {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const env = useMemo(
    () =>
      window?.location?.hostname.endsWith('.com') ?? false
        ? 'production'
        : 'development',
    [],
  );

  return (
    <>
      <AddressInput country={country} env={env} required />
      <TextInput
        {...register('fullName', {
          required: t('This field is required.'),
        })}
        label={t('Full Name')}
        required
        errors={
          errors['fullName']
            ? [errors['fullName'].message?.toString() ?? '']
            : []
        }
      />
      <EmailInput
        {...register('email')}
        label={t('Email address')}
        errors={
          errors['email'] ? [errors['email'].message?.toString() ?? ''] : []
        }
      />
      <PhoneInput
        {...register('phone')}
        name="phone"
        label={t('Phone')}
        errors={
          errors['phone'] ? [errors['phone'].message?.toString() ?? ''] : []
        }
      />
      <PhoneInput
        {...register('mobile')}
        label={t('Mobile phone')}
        errors={
          errors['mobile'] ? [errors['mobile'].message?.toString() ?? ''] : []
        }
      />
    </>
  );
}
